module.exports = __webpack_public_path__ + "static/68cf2aca-2c3b-4c72-9e1a-53f99d697752-500.25a7f234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/large-fluted-vase-sky-blue/68cf2aca-2c3b-4c72-9e1a-53f99d697752-500.jpg
// module id = 996
// module chunks = 168707334958949